import { createAction, props } from '@ngrx/store';
import {
  CreateOffMarketProperty,
  OffMarketProperty,
} from './off-market-properties.model';
import { ISearchRequest } from '../Authentication/auth.models';

export enum ActionTypes {
  GET_ADMIN_OFF_MARKET_PROPERTIES = '[Admin] Get Admin Off Market Properties',
  GET_ADMIN_OFF_MARKET_PROPERTIES_SUCCESS = '[Admin] Get Admin Off Market Properties Success',
  GET_ADMIN_OFF_MARKET_PROPERTIES_FAILURE = '[Admin] Get Admin Off Market Properties Failure',

  GET_ADMIN_OFF_MARKET_PROPERTY_DETAILS = '[Admin] Get Admin Off Market Property Details',
  GET_ADMIN_OFF_MARKET_PROPERTY_DETAILS_SUCCESS = '[Admin] Get Admin Off Market Property Details Success',
  GET_ADMIN_OFF_MARKET_PROPERTY_DETAILS_FAILURE = '[Admin] Get Admin Off Market Property Details Failure',

  CREATE_ADMIN_OFF_MARKET_PROPERTY = '[Admin] Create Admin Off Market Property',
  CREATE_ADMIN_OFF_MARKET_PROPERTY_SUCCESS = '[Admin] Create Admin Off Market Property Success',
  CREATE_ADMIN_OFF_MARKET_PROPERTY_FAILURE = '[Admin] Create Admin Off Market Property Failure',

  UPDATE_ADMIN_OFF_MARKET_PROPERTY = '[Admin] Update Admin Off Market Property',
  UPDATE_ADMIN_OFF_MARKET_PROPERTY_SUCCESS = '[Admin] Update Admin Off Market Property Success',
  UPDATE_ADMIN_OFF_MARKET_PROPERTY_FAILURE = '[Admin] Update Admin Off Market Property Failure',

  DELETE_ADMIN_OFF_MARKET_PROPERTY = '[Admin] Delete Admin Off Market Property',
  DELETE_ADMIN_OFF_MARKET_PROPERTY_SUCCESS = '[Admin] Delete Admin Off Market Property Success',
  DELETE_ADMIN_OFF_MARKET_PROPERTY_FAILURE = '[Admin] Delete Admin Off Market Property Failure',

  UPLOAD_ADMIN_OFF_MARKET_PROPERTY_DOCUMENTS = '[Admin] Upload Admin Off Market Property Documents',
  UPLOAD_ADMIN_OFF_MARKET_PROPERTY_DOCUMENTS_SUCCESS = '[Admin] Upload Admin Off Market Property Documents Success',
  UPLOAD_ADMIN_OFF_MARKET_PROPERTY_DOCUMENTS_FAILURE = '[Admin] Upload Admin Off Market Property Documents Failure',

  DELETE_ADMIN_OFF_MARKET_PROPERTY_DOCUMENT = '[Admin] Delete Admin Off Market Property Document',
  DELETE_ADMIN_OFF_MARKET_PROPERTY_DOCUMENT_SUCCESS = '[Admin] Delete Admin Off Market Property Document Success',
  DELETE_ADMIN_OFF_MARKET_PROPERTY_DOCUMENT_FAILURE = '[Admin] Delete Admin Off Market Property Document Failure',

  GENERATE_ADMIN_OFF_MARKET_PROPERTY_SHARE_LINK = '[Admin] Generate Admin Off Market Property Share Link',
  GENERATE_ADMIN_OFF_MARKET_PROPERTY_SHARE_LINK_SUCCESS = '[Admin] Generate Admin Off Market Property Share Link Success',
  GENERATE_ADMIN_OFF_MARKET_PROPERTY_SHARE_LINK_FAILURE = '[Admin] Generate Admin Off Market Property Share Link Failure',

  REVOKE_ADMIN_OFF_MARKET_PROPERTY_SHARE_LINK = '[Admin] Revoke Admin Off Market Property Share Link',
  REVOKE_ADMIN_OFF_MARKET_PROPERTY_SHARE_LINK_SUCCESS = '[Admin] Revoke Admin Off Market Property Share Link Success',
  REVOKE_ADMIN_OFF_MARKET_PROPERTY_SHARE_LINK_FAILURE = '[Admin] Revoke Admin Off Market Property Share Link Failure',
}

export const getAdminOffMarketProperties = createAction(
  ActionTypes.GET_ADMIN_OFF_MARKET_PROPERTIES,
  props<{ data: ISearchRequest }>()
);

export const getAdminOffMarketPropertiesSuccess = createAction(
  ActionTypes.GET_ADMIN_OFF_MARKET_PROPERTIES_SUCCESS,
  props<{ data: any }>()
);

export const getAdminOffMarketPropertiesFailure = createAction(
  ActionTypes.GET_ADMIN_OFF_MARKET_PROPERTIES_FAILURE,
  props<{ error: any }>()
);

export const getAdminOffMarketPropertyDetails = createAction(
  ActionTypes.GET_ADMIN_OFF_MARKET_PROPERTY_DETAILS,
  props<{ id: number }>()
);

export const getAdminOffMarketPropertyDetailsSuccess = createAction(
  ActionTypes.GET_ADMIN_OFF_MARKET_PROPERTY_DETAILS_SUCCESS,
  props<{ data: OffMarketProperty }>()
);

export const getAdminOffMarketPropertyDetailsFailure = createAction(
  ActionTypes.GET_ADMIN_OFF_MARKET_PROPERTY_DETAILS_FAILURE,
  props<{ error: any }>()
);

export const createAdminOffMarketProperty = createAction(
  ActionTypes.CREATE_ADMIN_OFF_MARKET_PROPERTY,
  props<{ data: CreateOffMarketProperty }>()
);

export const createAdminOffMarketPropertySuccess = createAction(
  ActionTypes.CREATE_ADMIN_OFF_MARKET_PROPERTY_SUCCESS,
  props<{ data: any }>()
);

export const createAdminOffMarketPropertyFailure = createAction(
  ActionTypes.CREATE_ADMIN_OFF_MARKET_PROPERTY_FAILURE,
  props<{ error: any }>()
);

export const updateAdminOffMarketProperty = createAction(
  ActionTypes.UPDATE_ADMIN_OFF_MARKET_PROPERTY,
  props<{ data: OffMarketProperty }>()
);

export const updateAdminOffMarketPropertySuccess = createAction(
  ActionTypes.UPDATE_ADMIN_OFF_MARKET_PROPERTY_SUCCESS,
  props<{ data: any }>()
);

export const updateAdminOffMarketPropertyFailure = createAction(
  ActionTypes.UPDATE_ADMIN_OFF_MARKET_PROPERTY_FAILURE,
  props<{ error: any }>()
);

export const deleteAdminOffMarketProperty = createAction(
  ActionTypes.DELETE_ADMIN_OFF_MARKET_PROPERTY,
  props<{ id: number; data: ISearchRequest }>()
);

export const deleteAdminOffMarketPropertySuccess = createAction(
  ActionTypes.DELETE_ADMIN_OFF_MARKET_PROPERTY_SUCCESS,
  props<{ data: any }>()
);

export const deleteAdminOffMarketPropertyFailure = createAction(
  ActionTypes.DELETE_ADMIN_OFF_MARKET_PROPERTY_FAILURE,
  props<{ error: any }>()
);

export const uploadAdminOffMarketPropertyDocuments = createAction(
  ActionTypes.UPLOAD_ADMIN_OFF_MARKET_PROPERTY_DOCUMENTS,
  props<{
    data: {
      propertyId: number;
      file: File;
      order: number;
    };
  }>()
);

export const uploadAdminOffMarketPropertyDocumentsSuccess = createAction(
  ActionTypes.UPLOAD_ADMIN_OFF_MARKET_PROPERTY_DOCUMENTS_SUCCESS,
  props<{ data: any }>()
);

export const uploadAdminOffMarketPropertyDocumentsFailure = createAction(
  ActionTypes.UPLOAD_ADMIN_OFF_MARKET_PROPERTY_DOCUMENTS_FAILURE,
  props<{ error: any }>()
);

export const deleteAdminOffMarketPropertyDocument = createAction(
  ActionTypes.DELETE_ADMIN_OFF_MARKET_PROPERTY_DOCUMENT,
  props<{ documentId: number; propertyId: number }>()
);

export const deleteAdminOffMarketPropertyDocumentSuccess = createAction(
  ActionTypes.DELETE_ADMIN_OFF_MARKET_PROPERTY_DOCUMENT_SUCCESS,
  props<{ data: any }>()
);

export const deleteAdminOffMarketPropertyDocumentFailure = createAction(
  ActionTypes.DELETE_ADMIN_OFF_MARKET_PROPERTY_DOCUMENT_FAILURE,
  props<{ error: any }>()
);

export const generateAdminOffMarketPropertyShareLink = createAction(
  ActionTypes.GENERATE_ADMIN_OFF_MARKET_PROPERTY_SHARE_LINK,
  props<{ propertyId: number }>()
);

export const generateAdminOffMarketPropertyShareLinkSuccess = createAction(
  ActionTypes.GENERATE_ADMIN_OFF_MARKET_PROPERTY_SHARE_LINK_SUCCESS,
  props<{ data: any }>()
);

export const generateAdminOffMarketPropertyShareLinkFailure = createAction(
  ActionTypes.GENERATE_ADMIN_OFF_MARKET_PROPERTY_SHARE_LINK_FAILURE,
  props<{ error: any }>()
);

export const revokeAdminOffMarketPropertyShareLink = createAction(
  ActionTypes.REVOKE_ADMIN_OFF_MARKET_PROPERTY_SHARE_LINK,
  props<{ propertyId: number }>()
);

export const revokeAdminOffMarketPropertyShareLinkSuccess = createAction(
  ActionTypes.REVOKE_ADMIN_OFF_MARKET_PROPERTY_SHARE_LINK_SUCCESS,
  props<{ data: any }>()
);

export const revokeAdminOffMarketPropertyShareLinkFailure = createAction(
  ActionTypes.REVOKE_ADMIN_OFF_MARKET_PROPERTY_SHARE_LINK_FAILURE,
  props<{ error: any }>()
);
